"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationEvents = void 0;
class NotificationEvents {
    builder;
    constructor(builder) {
        this.builder = builder;
    }
    static notification(builder) {
        return new NotificationEvents(builder);
    }
    addPart(part) {
        this.builder.addPart(part);
        return this;
    }
    toString() {
        return this.builder.toString();
    }
    get create() {
        return this.builder.addPart("create").toString();
    }
    get newCampaign() {
        return this.builder.addPart("new_campaign").toString();
    }
    get wildcard() {
        return this.builder.wildcard;
    }
}
exports.NotificationEvents = NotificationEvents;
